import { Box, Button, darken, type SxProps } from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import { useBehaviorSubject } from '@ocodelib/mui/hooks';
import type { ReactNode } from 'react';
import { usePyBasicApp } from '../usePyBasicApp';
import { ContentTab } from './ContentTab';

interface Props {
  sx?: SxProps;
  tabNames: Record<string, string>;
  children?: ReactNode;
}

export function ContentTabs(props: Props) {
  const { sx, tabNames, children } = props;
  const { appManager } = usePyBasicApp();
  const contentTabKeys = useBehaviorSubject(appManager.uiState.contentTabs$);
  const currentTabKey = useBehaviorSubject(appManager.uiState.currentContentTab$);

  return (
    <Box
      sx={flatSx(
        {
          display: 'flex',
          alignItems: 'flex-end',
          pt: 0.5,
          pl: 2,
          height: 40,
          color: 'primary.contrastText',
          bgcolor: 'primary.main',
          '& .ContentTab-root': {
            '& + .ContentTab-root': {
              ml: '2px',
            },
          },
        },
        sx,
      )}
    >
      {contentTabKeys?.map((tabKey) => (
        <ContentTab
          key={tabKey}
          title={tabNames[tabKey] ?? tabKey}
          active={currentTabKey === tabKey}
          onClick={() => {
            appManager.uiState.setCurrentContentTab(tabKey);
          }}
        />
      ))}
      <Box
        sx={{
          ml: 2,
          mb: '4px',
          color: 'primary.contrastText',
        }}
      >
        <Button
          color="inherit"
          variant="outlined"
          size="small"
          onClick={() => {
            document.dispatchEvent(
              new CustomEvent('lecture-dialog-open', {
                detail: {
                  lectureKey: 'lecture.py-basic',
                },
              }),
            );
          }}
        >
          기초학습
        </Button>
      </Box>
      {children}
    </Box>
  );
}
